import React from "react";
import { useNavigate } from "react-router-dom";
import userImage from "../../assets/icons/user.png";
import { useAdminAuth } from "../../utils/useAuth";
import { VscDashboard } from "react-icons/vsc";
import { BiWorld } from "react-icons/bi";
import { FaSignOutAlt, FaUser } from "react-icons/fa";
import { secureStorage } from "../../utils/secureStorage";
import Logo from "../../assets/logo/logo.svg";
import MobileSidebar from "./MobileSidebar";

const Header = () => {
  const { isAdmin } = useAdminAuth();
  const navigate = useNavigate();
  const handleLogout = () => {
    secureStorage.removeItem("adminToken");
    secureStorage.removeItem("admin");
    window.location.replace("/admin/auth");
  };
  return (
    <div className="w-full h-[60px] flex justify-between items-center px-3 lg:px-10  bg-white">
      <div className="justify-center items-center py-2 h-[60px] bg-white sticky top-0 z-10">
        <img
          className="w-[150px] flex lg:hidden "
          src={Logo}
          alt="Dhoorbin.com"
        />
      </div>
      <div className="block lg:hidden">
        <MobileSidebar />
      </div>
      <div className="relative justify-self-end group hidden lg:flex space-x-4">
        <button className="w-12 h-12 overflow-hidden rounded-full">
          <img src={userImage} alt="" />
        </button>

        {isAdmin && (
          <div className="absolute top-full right-0 mt-0 w-[200px] p-3 border rounded-lg bg-white shadow-md opacity-0 pointer-events-none transition-opacity duration-200 group-hover:opacity-100 group-hover:pointer-events-auto z-50">
            <div className="space-y-3">
              <div
                onClick={() => navigate("/admin/dashboard")}
                className="flex justify-start items-center gap-1 p-1 text-sm text-black/70 bg-white hover:bg-[#d5e2f8] duration-300 rounded-lg hover:font-bold cursor-pointer"
              >
                <VscDashboard />
                <p>Dashboard</p>
              </div>
              <div
                onClick={() => navigate("/admin/order/hotels")}
                className="flex justify-start items-center gap-1 p-1 text-sm text-black/70 bg-white hover:bg-[#d5e2f8] duration-300 rounded-lg hover:font-bold cursor-pointer"
              >
                <BiWorld />
                <p>Hotel Bookings</p>
              </div>
              <div
                onClick={() => navigate("/admin/order/tours")}
                className="flex justify-start items-center gap-1 p-1 text-sm text-black/70 bg-white hover:bg-[#d5e2f8] duration-300 rounded-lg hover:font-bold cursor-pointer"
              >
                <BiWorld />
                <p>Tour Bookings</p>
              </div>
              <div
                onClick={() => navigate("/admin/users")}
                className="flex justify-start items-center gap-1 p-1 text-sm text-black/70 bg-white hover:bg-[#d5e2f8] duration-300 rounded-lg hover:font-bold cursor-pointer"
              >
                <FaUser />
                <p>Users</p>
              </div>
              <div
                onClick={handleLogout}
                className="flex justify-start items-center gap-1 p-1 text-sm text-black/70 bg-white hover:bg-[#d5e2f8] duration-300 hover:text-red-500 rounded-lg hover:font-bold cursor-pointer"
              >
                <FaSignOutAlt />
                <p>Logout</p>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Header;
